import React from 'react';
import PropTypes from 'prop-types';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

const AfterSalesMessage = ({ rule, timezone, currency }) => {
  const messageId = `afterSalesRule.${rule.type.toLowerCase()}.${rule.price === 0 ? 'free' : 'fee'}`;
  const date = moment.parseZone(rule.validUntil);
  const fee = <FormattedCurrency amount={rule.price} currency={currency} />;

  return (
    <div>
      <FormattedMessage id={messageId} values={{ fee }} />
      {` ${date.format('DD MMM YYYY')} `}
      <FormattedMessage id="journeySummaryBox.at" />
      {` ${date.format('HH:mm')} ${timezone} `}
      <FormattedMessage id="journeySummaryBox.time" />
    </div>
  );
};

AfterSalesMessage.propTypes = {
  rule: PropTypes.shape({
    type: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    validUntil: PropTypes.string.isRequired
  }).isRequired,
  timezone: PropTypes.string.isRequired,
  currency: PropTypes.string
};

export default AfterSalesMessage;
